import { TextCell } from '@common/components/TextCell';

interface DateCreatedCellProps {
	dateCreated: string;
}

export const DateCreatedCell = ({ dateCreated }: DateCreatedCellProps) => {
	return <TextCell value={dateCreated} />;
};
